<section>
    <nz-spin [nzSpinning]="isLoading">
        <form nz-form #form="ngForm" (ngSubmit)="submit()">
            <div class="drawer-form-header-empty"></div>
            <div nz-row class="drawer-form-header">
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <div class="heading-fs-18 mb-0">
                        <span nz-icon nzType="arrow-left" nzTheme="outline" class="drawer-back-arrow mr-2 disp-mob"
                            (click)="cancel()"></span>
                        New Media
                    </div>
                </div>
                <div nz-col nzSpan="12" class="text-right disp-web">
                    <button nz-button class="mr-3" type="button" (click)="cancel()">Cancel</button>
                    <button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Save</button>
                </div>
                <div nz-col nzSpan="24">
                    <nz-divider></nz-divider>
                </div>
            </div>

            <div nz-row class="mb-3">
                <div nz-col nzSpan="24">
                    <div class="media-type-header">
                        <div nz-row>
                            <div nz-col nzLg="12" nzMd="12" nzXs="12" nzSm="12" class="content-center">
                                <div class="align-items-center">
                                    <img class="media-type-header-img-wrapper" [src]="mediaAppModel.iconUrl"
                                        alt="media-type">

                                    <span class="ml-2 fs-16 fw-bold">{{mediaAppModel.title}}</span>
                                </div>
                            </div>
                            <div nz-col nzLg="12" nzMd="12" nzXs="12" nzSm="12" class="media-type-header-content">
                                <app-content-text-view
                                    [contentType]="constants.pageContentType.mediaAppWebTop"></app-content-text-view>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div nz-row class="mobOne-action-m-b">
                <div nz-col nzSpan="24">
                    <div class="input-container">
                        <nz-form-item>
                            <nz-form-control class="mb-0"
                                [nzValidateStatus]="mediaName.invalid && (mediaName.dirty || mediaName.touched) ? 'error' : ''">
                                <nz-form-label [nzRequired]="true">Media name</nz-form-label>
                                <nz-input-group>
                                    <input nz-input required placeholder="Enter your media name" name="mediaName"
                                        #mediaName="ngModel" [(ngModel)]="model.title" [minlength]="1" [maxlength]="100"
                                        appAlphaNumericsLevelThree required />
                                </nz-input-group>
                                <div *ngIf="form.submitted || mediaName?.touched || mediaName?.dirty"
                                    class="validation-error-message">
                                    <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                        class="validation-icon mt-1" *ngIf="mediaName?.errors"></span>
                                    <span *ngIf="mediaName?.errors?.['required']" class="ml-1"> Media
                                        name
                                        is required. </span>
                                </div>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>

                <div nz-col nzSpan="24" class="mb-1 mt-3">
                    You can show just about any web content on your screens.
                    <span nz-icon nzType="exclamation-circle" nzTheme="outline" nz-tooltip nzTooltipTitle="Enter a URL to display web content directly on your screens. Ensure the website is accessible and supports embedding for a seamless display experience."
                        class="label-icon"></span>
                </div>

                <div nz-col nzSpan="24">
                    <div class="input-container">
                        <nz-form-item>
                            <nz-form-control class="mb-0"
                                [nzValidateStatus]="url.invalid && (url.dirty || url.touched) ? 'error' : ''">
                                <nz-form-label [nzRequired]="true">URL</nz-form-label>
                                <nz-input-group>
                                    <input nz-input placeholder="Enter URL" name="url" #url="ngModel"
                                        [(ngModel)]="model.webPage.url" [pattern]="appUtils.urlRegexPattern" required />
                                </nz-input-group>
                                <div *ngIf="form.submitted || url?.touched || url?.dirty"
                                    class="validation-error-message">
                                    <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                        class="validation-icon mt-1" *ngIf="url?.errors"></span>
                                    <span *ngIf="url?.errors?.['required']" class="ml-1"> URL
                                        is required. </span>
                                    <span *ngIf="url?.errors?.['pattern']" class="ml-1">Invalid URL
                                    </span>
                                </div>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>

                <!-- Display Options Section -->
                <div nz-col nzSpan="24" class="mt-3">
                        <div class="pb-3">
                            Display Options
                            <span
                                nz-icon
                                nzType="exclamation-circle"
                                nzTheme="outline"
                                class="label-icon"
                                nz-tooltip
                                nzTooltipTitle="Configure how the web page is displayed on your screens, including zoom level and refresh settings. Requires TV player v110 or above."
                            ></span>
                        </div>

                        <!-- Auto-zoom Switch -->
                        <div class="input-container pb-3">
                            <nz-form-item>
                                <nz-form-control class="mb-0">
                                    <nz-form-label>Auto-zoom (screen resolution)</nz-form-label>
                                    <nz-switch
                                        [(ngModel)]="model.webPage.autoZoom"
                                        name="autoZoom"
                                        (ngModelChange)="onAutoZoomChange($event)"
                                    >
                                    </nz-switch>
                                    <div class="form-help-text mt-1">
                                        Automatically scales content to fit your TV screen resolution
                                    </div>
                                </nz-form-control>
                            </nz-form-item>
                        </div>

                        <!-- Manual Zoom Control (only shown when auto-zoom is OFF) -->
                        <div
                            class="input-container pb-3"
                            *ngIf="!model.webPage.autoZoom"
                        >
                            <nz-form-item>
                                <nz-form-control
                                    class="mb-0"
                                    [nzValidateStatus]="
                                        zoomPercent.invalid &&
                                        (zoomPercent.dirty || zoomPercent.touched)
                                            ? 'error'
                                            : ''
                                    "
                                >
                                    <nz-form-label [nzRequired]="!model.webPage.autoZoom">Zoom (percent)</nz-form-label>
                                    <div nz-row [nzGutter]="16" class="align-items-center">
                                        <div nz-col nzSpan="16">
                                            <nz-slider
                                                [(ngModel)]="model.webPage.zoomPercent"
                                                name="zoomSlider"
                                                [nzMin]="1"
                                                [nzMax]="999"
                                                [nzStep]="1"
                                                [nzTooltipVisible]="'default'"
                                                nzTooltipPlacement="top"
                                                [nzDisabled]="model.webPage.autoZoom"
                                            >
                                            </nz-slider>
                                        </div>
                                        <div nz-col nzSpan="8">
                                            <nz-input-group nzSuffix="%">
                                                <input
                                                    nz-input
                                                    type="number"
                                                    placeholder="100"
                                                    name="zoomPercent"
                                                    #zoomPercent="ngModel"
                                                    [(ngModel)]="model.webPage.zoomPercent"
                                                    [min]="1"
                                                    [max]="999"
                                                    [required]="!model.webPage.autoZoom"
                                                    [disabled]="model.webPage.autoZoom"
                                                />
                                            </nz-input-group>
                                        </div>
                                    </div>
                                    <div
                                        *ngIf="
                                            (form.submitted ||
                                                zoomPercent?.touched ||
                                                zoomPercent?.dirty) &&
                                            !model.webPage.autoZoom
                                        "
                                        class="validation-error-message"
                                    >
                                        <span
                                            nz-icon
                                            nzType="exclamation-circle"
                                            nzTheme="fill"
                                            class="validation-icon mt-1"
                                            *ngIf="zoomPercent?.errors"
                                        ></span>
                                        <span
                                            *ngIf="zoomPercent?.errors?.['required']"
                                            class="ml-1"
                                            >Zoom percent is required when auto-zoom is disabled.</span
                                        >
                                        <span
                                            *ngIf="zoomPercent?.errors?.['min']"
                                            class="ml-1"
                                            >Zoom must be at least 1%.</span
                                        >
                                        <span
                                            *ngIf="zoomPercent?.errors?.['max']"
                                            class="ml-1"
                                            >Zoom cannot exceed 999%.</span
                                        >
                                    </div>
                                </nz-form-control>
                            </nz-form-item>
                        </div>

                        <!-- Refresh Interval Control -->
                        <div class="input-container pt-3">
                            <nz-form-item>
                                <nz-form-control
                                    class="mb-0"
                                    [nzValidateStatus]="
                                        refreshInterval.invalid &&
                                        (refreshInterval.dirty || refreshInterval.touched)
                                            ? 'error'
                                            : ''
                                    "
                                >
                                    <nz-form-label>Refresh interval (seconds)</nz-form-label>
                                    <nz-input-group nzSuffix="seconds">
                                        <input
                                            nz-input
                                            type="number"
                                            placeholder="0 (disabled)"
                                            name="refreshInterval"
                                            #refreshInterval="ngModel"
                                            [(ngModel)]="model.webPage.refreshInterval"
                                            [min]="0"
                                        />
                                    </nz-input-group>
                                    <div class="form-help-text mt-1">
                                        Set to 0 to disable automatic refresh. If this media is used in playlists, the page will refresh each time it cycles through the playlist.<br />
                                        <strong>Using this media in a Broadcast?</strong> It will not refresh unless the broadcast ends and begins again. You can set a refresh interval to keep the page alive and content fresh if needed.
                                    </div>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                </div>

                <!-- Custom Headers Section -->
                <div nz-col nzSpan="24" class="mt-3">
                        <div class="pb-3">
                            <label class="d-flex align-items-center">Pass custom header values
                                <span
                                    nz-icon
                                    nzType="exclamation-circle"
                                    nzTheme="outline"
                                    class="label-icon"
                                    nz-tooltip
                                    nzTooltipTitle="Advanced users: you can use headers to serve targeted content, improve security with authentication or enable enhanced caching and analytics. Your custom headers are stored and sent to your screens in a secure manner."
                                ></span>
                                <span class="ml-3">
                                    <nz-switch
                                        [(ngModel)]="showHeaderValues"
                                        (ngModelChange)="onHeaderValuesToggle()"
                                        name="headerValues"
                                    ></nz-switch>
                                </span>
                            </label>
                        </div>
                        
                        <div nz-row *ngIf="showHeaderValues">
                            <div nz-col nzSpan="24">
                                <nz-divider></nz-divider>
                            </div>
                        </div>

                        <div
                            nz-row
                            [nzGutter]="[16]"
                            class="mt-2"
                            *ngIf="
                                showHeaderValues &&
                                model.webPage.headerValues &&
                                model.webPage.headerValues.length > 0
                            "
                        >
                            <div
                                nz-col
                                nzSpan="24"
                                *ngFor="
                                    let header of model.webPage.headerValues;
                                    let i = index;
                                    trackBy: trackByIndex
                                "
                            >
                                <div nz-row [nzGutter]="[16]" class="mb-3">
                                    <div nz-col nzXs="24" nzSm="11" nzMd="11" nzLg="11" nzXl="11">
                                        <div class="input-container">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <nz-form-label>Header Key</nz-form-label>
                                                    <nz-input-group>
                                                        <input
                                                            nz-input
                                                            placeholder="e.g., Authorization, X-API-Key"
                                                            [(ngModel)]="header.key"
                                                            [name]="'headerKey_' + i"
                                                        />
                                                    </nz-input-group>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                    </div>
                                    <div nz-col nzXs="24" nzSm="11" nzMd="11" nzLg="11" nzXl="11">
                                        <div class="input-container">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <nz-form-label>Header Value</nz-form-label>
                                                    <nz-input-group>
                                                        <input
                                                            nz-input
                                                            placeholder="e.g., Bearer token123, your-api-key-value"
                                                            [(ngModel)]="header.value"
                                                            [name]="'headerValue_' + i"
                                                        />
                                                    </nz-input-group>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                    </div>
                                    <div
                                        nz-col
                                        nzXs="24"
                                        nzSm="2"
                                        nzMd="2"
                                        nzLg="2"
                                        nzXl="2"
                                        class="d-flex align-items-end btn-remove-header"
                                    >
                                        <button
                                            type="button"
                                            nz-button
                                            nzType="text"
                                            nzDanger
                                            (click)="removeHeaderValue(i)"
                                            nz-tooltip
                                            nzTooltipTitle="Remove this header"
                                        >
                                            <span nz-icon nzType="delete" nzTheme="outline"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="mt-2"
                            *ngIf="
                                showHeaderValues &&
                                (!model.webPage.headerValues ||
                                    model.webPage.headerValues.length === 0)
                            "
                        >
                            <div class="text-muted">No custom headers added.</div>
                        </div>

                        <div class="mt-3" *ngIf="showHeaderValues">
                            <button
                                type="button"
                                nz-button
                                nzType="dashed"
                                (click)="addHeaderValue()"
                                class="w-100"
                            >
                                <span nz-icon nzType="plus" nzTheme="outline"></span>
                                Add Header Value
                            </button>
                        </div>
                </div>

                <div nz-col nzSpan="24" class="mt-3">
                    <div class="input-container">
                        <nz-form-item>
                            <nz-form-control [ngClass]="isTyping ? 'hide-max-placeholder' : ''">
                                <nz-form-label>Playlist(s)
                                    <span nz-icon nzType="exclamation-circle" nzTheme="outline" nz-tooltip
                                        nzTooltipTitle="Select Playlist" class="label-icon"></span>
                                </nz-form-label>
                                <nz-select name="displayList" [(ngModel)]="selectedDisplayLists" [nzShowArrow]="true"
                                    nzPlaceHolder="Select Playlist" nzMode="multiple" [nzMaxTagCount]="0"
                                    [nzMaxTagPlaceholder]="isTyping ? null : maxTagPlaceholder"
                                             (nzOnSearch)="onSearch($event)">
                                    <nz-option *ngFor="let item of displayLists" [nzValue]="item"
                                        nzLabel="{{item.value}}"></nz-option>
                                    <nz-option *ngIf="displayLists.length == 0" nzDisabled
                                        nzLabel="No playlist added."></nz-option>
                                </nz-select>
                                <ng-template #maxTagPlaceholder let-selected>
                                    {{ selected.length }} item selected
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <div nz-col nzSpan="24" class="mb-3" *ngIf="selectedDisplayLists.length > 0">
                    <div class="selected-chip-container">
                        <nz-tag nzMode="closeable" class="selected-tag" (click)="removeDisplay(item)"
                            *ngFor="let item of selectedDisplayLists">
                        <span class="selected-tag-content">{{item.value}}</span></nz-tag>
                    </div>
                </div>

                <div nz-col nzSpan="24">
                    <div class="input-container">
                        <nz-form-item>
                            <nz-form-control>
                                <nz-form-label>Group
                                    <span nz-icon nzType="exclamation-circle" nzTheme="outline" class="label-icon"
                                        nz-tooltip nzTooltipTitle="Groups allow you to share things within manager with other people."></span>
                                </nz-form-label>
                                <nz-select nzPlaceHolder="Select group" name="groupId" #groupId="ngModel"
                                    [(ngModel)]="model.groupId" (ngModelChange)="onGroupChange()" [nzDisabled]="true">
                                    <nz-option *ngFor="let item of subscriptionPlans" [nzValue]="item.keyInt"
                                        nzLabel="{{item.value}}"></nz-option>
                                </nz-select>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <div nz-col nzSpan="24">
                    <div class="input-container">
                        <nz-form-item>
                            <nz-form-control>
                                <nz-form-label>Folder
                                    <span nz-icon nzType="exclamation-circle" nzTheme="outline" class="label-icon"
                                        nz-tooltip nzTooltipTitle="Organize items in Manager with folders."></span>
                                </nz-form-label>
                                <nz-select nzPlaceHolder="Select folder" name="folderId" [(ngModel)]="model.folderId">
                                    <nz-option *ngFor="let item of folders" [nzValue]="item.keyInt"
                                        nzLabel="{{item.value}}"></nz-option>
                                    <nz-option *ngIf="folders.length == 0" nzLabel="No folder Added" nzValue="disabled"
                                        nzDisabled></nz-option>
                                </nz-select>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <div nz-col nzSpan="24" class="mb-3">
                    <div nz-row>
                        <div nz-col nzSpan="24">
                            <div class="align-items-center">
                                <label class="mr-3" for="" class="fs-16 mb-0 fw-bold">Schedule</label>
                                <span class="ml-3"><app-feature-lock featureKey="advanced_media_scheduling"><nz-switch [(ngModel)]="isScheduled" (ngModelChange)="onSchedule()"
                                        name="schedule" #schedule="ngModel"></nz-switch></app-feature-lock></span>
                            </div>
                            <div nz-row *ngIf="isScheduled">
                                <div nz-col nzSpan="24">
                                    <nz-divider></nz-divider>
                                </div>
                            </div>
                            <div nz-row class="mt-2 ml-2" *ngIf="isScheduled">
                                <div nz-col nzSpan="24">
                                    <nz-radio-group [(ngModel)]="model.isDaily" name="isDaily" #isDaily="ngModel"
                                        (ngModelChange)="scheduleTypeChanged($event)">
                                        <label nz-radio [nzValue]="true">Daily</label>
                                        <label nz-radio [nzValue]="false">Date range</label>
                                    </nz-radio-group>
                                </div>
                            </div>

                            <div nz-row [nzGutter]="[16]" class="mt-2" *ngIf="isScheduled">
                                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                    <div class="input-container">
                                        <nz-form-item>
                                            <nz-form-control class="mt-3 mb-0">
                                                <nz-form-label>Start time</nz-form-label>
                                                <nz-time-picker [nzUse12Hours]="true" [nzAllowEmpty]="false"
                                                    (ngModelChange)="isStartTimeValid($event)" class="cursor-pointer"
                                                    [(ngModel)]="scheduleStartTime" name="startTime"
                                                    #startTime="ngModel" nzFormat="hh:mm a" nzPlaceHolder="Select"
                                                    required>
                                                </nz-time-picker>
                                                <div *ngIf="form.submitted || startTime?.touched"
                                                    class="validation-error-message">
                                                    <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                                        class="validation-icon mt-1" *ngIf="startTime?.errors"></span>
                                                    <span *ngIf="startTime?.errors?.['required']" class="ml-1">Start
                                                        time is
                                                        required</span>
                                                </div>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                </div>
                                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                    <div class="input-container">
                                        <nz-form-item>
                                            <nz-form-control class="mt-3 mb-0">
                                                <nz-form-label>End time</nz-form-label>
                                                <nz-time-picker [nzUse12Hours]="true" class="cursor-pointer"
                                                    (ngModelChange)="isTimeValid($event)" [nzAllowEmpty]="false"
                                                    [(ngModel)]="scheduleEndTime" name="endTime" #endTime="ngModel"
                                                    nzFormat="hh:mm a" nzPlaceHolder="Select" required>
                                                </nz-time-picker>
                                                <div *ngIf="form.submitted || endTime?.touched"
                                                    class="validation-error-message">
                                                    <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                                        class="validation-icon mt-1"
                                                        *ngIf="(endTime?.errors) || (!endTime?.errors?.['required'] && !isEndTimeValid)"></span>
                                                    <span *ngIf="endTime?.errors?.['required']" class="ml-1">End
                                                        time is required</span>
                                                    <span *ngIf="!endTime?.errors?.['required'] && !isEndTimeValid"
                                                        class="ml-1">Please select any future time</span>
                                                </div>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                </div>
                            </div>
                            <div nz-row [nzGutter]="[16]" *ngIf="isScheduled && !model.isDaily">
                                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                    <div class="input-container">
                                        <nz-form-item>
                                            <nz-form-control class="mt-3 mb-0">
                                                <nz-form-label>Start date</nz-form-label>
                                                <nz-date-picker nzFormat="MM/dd/yyyy" name="startDate"
                                                    [nzAllowClear]="false" [(ngModel)]="model.startDate"
                                                    #startDate="ngModel" [nzDisabledDate]="disableStartDate"
                                                    nzPlaceHolder="Select" class="cursor-pointer"></nz-date-picker>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                </div>
                                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                    <div class="input-container">
                                        <nz-form-item>
                                            <nz-form-control class="mt-3 mb-0">
                                                <nz-form-label>End date</nz-form-label>
                                                <nz-date-picker nzFormat="MM/dd/yyyy" name="endDate"
                                                    [nzAllowClear]="false" [(ngModel)]="model.endDate"
                                                    #endDate="ngModel" [nzDisabledDate]="disableEndDate"
                                                    nzPlaceHolder="Select" class="cursor-pointer"></nz-date-picker>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div nz-col nzSpan="24" class="mt-2 mb-3">
                    <div class="align-items-center">
                        <label class="mr-3" for="" class="fs-16 mb-0 fw-bold">Show this media</label>
                        <span nz-icon nzType="exclamation-circle" nzTheme="outline" nz-tooltip
                            nzTooltipTitle="Show or hide media" class="label-icon"></span>
                        <span class="ml-3"><nz-switch [(ngModel)]="model.webPage.isEnabled" name="isenabled"
                                #isEnabled="ngModel"></nz-switch></span>
                    </div>
                </div>

                <!-- <div nz-row class="mb-3"> -->
                <div nz-col nzSpan="24">
                    <div class="input-container">
                        <nz-form-item>
                            <nz-form-control class="mb-0">
                                <nz-form-label>Notes</nz-form-label>
                                <nz-textarea-count [nzMaxCharacterCount]="100">
                                    <textarea rows="2" nz-input placeHolder="Enter Notes" name="description"
                                        #description="ngModel" [(ngModel)]="model.description"
                                        [maxlength]="100"></textarea>
                                </nz-textarea-count>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
            </div>

            <div nz-row class="disp-mob mobOne-action-bar">
                <div nz-col nzSpan="24" class="text-right">
                    <nz-card>
                        <div nz-row [nzGutter]="[16]">
                            <div nz-col nzSpan="12">
                                <button nz-button class="btn-full" type="button" (click)="cancel()">Cancel</button>
                            </div>
                            <div nz-col nzSpan="12">
                                <button nz-button class="btn-full" nzType="primary"
                                    [disabled]="form.invalid">Save</button>
                            </div>
                        </div>
                    </nz-card>
                </div>
            </div>
        </form>
    </nz-spin>
</section>